import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/GIC/login" />} />
      <Route path="/:site/login" element={<LoginPage />} />
    </Routes>
  );
}
